import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, Copy } from 'lucide-react';
import { writeToClipboard } from '../lib/clipboard';
import { toast } from 'sonner';

// The one place the app tells you how to reach us. Reached from Account settings
// and from the author's moderation notice, so the copy has to work for both
// without naming a reporter or revealing anything about a review.
const CONTACT_EMAIL = 'phillip@tautuatech.com';
const MAIL_SUBJECT = 'Recommendation removed from Explore';

export const Contact = () => {
  const navigate = useNavigate();

  // Arriving from a scrolled screen must not hide the first line of the copy.
  // Braces are load-bearing: a concise arrow would hand scrollTo's return value
  // to React as the effect cleanup, and React calls anything that is not
  // undefined.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // A device with no mail app configured cannot act on a mailto: link, so the
  // address itself has to be takeable.
  const handleCopy = async () => {
    if (await writeToClipboard(CONTACT_EMAIL)) toast.success('Email address copied');
    else toast.error('Could not copy the email address');
  };

  return (
    <div className="page" data-testid="contact-page">
      <header className="page-header">
        <div className="connections-header-top">
          <button
            className="back-btn"
            onClick={() => navigate(-1)}
            aria-label="Go back"
            data-testid="contact-back"
          >
            <ArrowLeft />
          </button>
          <h1 className="page-title">Contact us</h1>
        </div>
      </header>

      <section className="appearance-section" data-testid="contact-section">
        <p className="connections-subtitle" data-testid="contact-copy">
          Need to contact us? Email us at{' '}
          <a
            className="moderation-notice-link"
            href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(MAIL_SUBJECT)}`}
            data-testid="contact-email-link"
          >
            {CONTACT_EMAIL}
          </a>
          . If you&apos;re contacting us about a recommendation that was removed from Explore and
          think the decision should be reviewed, tell us what happened and we&apos;ll take another
          look.
        </p>
        <div className="contact-actions">
          <a
            className="connect-cta-btn"
            href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(MAIL_SUBJECT)}`}
            data-testid="contact-email-btn"
          >
            <Mail className="connect-cta-icon" />
            Email us
          </a>
          <button
            type="button"
            className="placeholder-btn secondary contact-copy-btn"
            onClick={handleCopy}
            data-testid="contact-copy-btn"
          >
            <Copy className="connect-cta-icon" aria-hidden="true" />
            Copy email
          </button>
        </div>
      </section>
    </div>
  );
};
